document.addEventListener('DOMContentLoaded', function () {
    (function () {
        const STORAGE_KEY = 'cookie_consent_v4';
        let currentState = null;
        let cookieSettings = {
            analytics: true,
            functional: true,
            marketing: true
        };

        let metrikaLoaded = false;

        const banner = document.getElementById('cookieBanner');
        const body = document.body;
        const acceptBtn = document.getElementById('acceptAllBtn');
        const rejectBtn = document.getElementById('rejectAllBtn');
        const customizeBtn = document.getElementById('customizeBtn');
        const modal = document.getElementById('preferencesModal');
        const savePrefBtn = document.getElementById('savePreferencesBtn');
        const closeModalBtn = document.getElementById('closeModalBtn');
        const restoreBtn = document.getElementById('restoreCookiesBtn');
        const analyticsChk = document.getElementById('analyticsCookie');
        const functionalChk = document.getElementById('functionalCookie');
        const marketingChk = document.getElementById('marketingCookie');
        const rejectionOverlay = document.getElementById('rejectionOverlay');
        const rejectionCustomizeBtn = document.getElementById('rejectionCustomizeBtn');
        const resetBtn = document.getElementById('resetCookieBtn');

        function loadYandexMetrika() {
            if (metrikaLoaded) return;

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.innerHTML = `
                (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
                
                ym(99999999, "init", {
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                    ecommerce: "dataLayer"
                });
            `;
            document.head.appendChild(script);

            const noscript = document.createElement('noscript');
            const img = document.createElement('img');
            img.src = 'https://mc.yandex.ru/watch/99999999';
            img.style.position = 'absolute';
            img.style.left = '-9999px';
            img.alt = '';
            noscript.appendChild(img);
            document.body.appendChild(noscript);

            metrikaLoaded = true;
        }

        function unloadYandexMetrika() {
            if (!metrikaLoaded) return;

            try {
                if (window.ym && window.ym.a) {
                    window.ym.a = [];
                }
                window.ym = function () { };
                window.ym.a = [];

                const scripts = document.querySelectorAll('script[src*="metrika"], script[src*="mc.yandex"]');
                scripts.forEach(script => script.remove());

                const noscripts = document.querySelectorAll('noscript');
                noscripts.forEach(noscript => {
                    if (noscript.innerHTML.includes('mc.yandex')) {
                        noscript.remove();
                    }
                });

                metrikaLoaded = false;
            } catch (e) { }
        }

        function applyCookieConsent() {
            if (currentState === null) return;

            const analyticsEnabled = cookieSettings.analytics === true;
            const functionalEnabled = cookieSettings.functional === true;
            const marketingEnabled = cookieSettings.marketing === true;

            if (analyticsEnabled && !metrikaLoaded && currentState !== null) {
                loadYandexMetrika();
            } else if (!analyticsEnabled && metrikaLoaded) {
                unloadYandexMetrika();
            }

            if (functionalEnabled) {
                document.documentElement.setAttribute('data-functional', 'enabled');
            } else {
                document.documentElement.setAttribute('data-functional', 'disabled');
            }

            const existingPixel = document.getElementById('marketing-pixel');
            if (marketingEnabled && !existingPixel) {
                const pixel = document.createElement('img');
                pixel.id = 'marketing-pixel';
                pixel.style.display = 'none';
                pixel.alt = '';
                pixel.src = 'https://placehold.co/1x1';
                document.body.appendChild(pixel);
            } else if (!marketingEnabled && existingPixel) {
                existingPixel.remove();
            }
        }

        function updateUI() {
            body.classList.remove('cookie--banner-active');
            body.classList.remove('cookie--only-necessary');

            if (currentState === null) {
                if (banner) banner.classList.remove('cookie-banner--hidden');
                body.classList.add('cookie--banner-active');
                if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
            } else if (currentState === 'only_necessary') {
                if (banner) banner.classList.add('cookie-banner--hidden');
                body.classList.remove('cookie--banner-active');
                if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
                body.classList.add('cookie--only-necessary');
            } else if (currentState === 'all_accepted' || currentState === 'customized') {
                if (banner) banner.classList.add('cookie-banner--hidden');
                body.classList.remove('cookie--banner-active');
                if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
                body.classList.remove('cookie--only-necessary');
            }

            applyCookieConsent();
        }

        function saveToLocalStorage() {
            const data = {
                state: currentState,
                settings: cookieSettings
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        }

        function loadFromLocalStorage() {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (!saved) {
                currentState = null;
                cookieSettings = {
                    analytics: true,
                    functional: true,
                    marketing: true
                };
                updateUI();
                return;
            }
            try {
                const data = JSON.parse(saved);
                currentState = data.state;
                cookieSettings = data.settings || {
                    analytics: false,
                    functional: false,
                    marketing: false
                };

                if (currentState === 'all_accepted') {
                    cookieSettings = {
                        analytics: true,
                        functional: true,
                        marketing: true
                    };
                }
                if (currentState === 'only_necessary') {
                    cookieSettings = {
                        analytics: false,
                        functional: false,
                        marketing: false
                    };
                }
                updateUI();
            } catch (e) {
                currentState = null;
                updateUI();
            }
        }

        function acceptAll() {
            currentState = 'all_accepted';
            cookieSettings = {
                analytics: true,
                functional: true,
                marketing: true
            };
            saveToLocalStorage();
            updateUI();
            closeModal();
            if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
        }

        function rejectAll() {
            currentState = 'only_necessary';
            cookieSettings = {
                analytics: false,
                functional: false,
                marketing: false
            };
            saveToLocalStorage();
            updateUI();
            closeModal();
            if (rejectionOverlay) rejectionOverlay.classList.add('cookie-rejection--visible');
        }

        function openCustomize() {
            if (analyticsChk) analyticsChk.checked = cookieSettings.analytics;
            if (functionalChk) functionalChk.checked = cookieSettings.functional;
            if (marketingChk) marketingChk.checked = cookieSettings.marketing;
            if (modal) modal.classList.add('cookie-preferences--visible');
            if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
            body.classList.remove('cookie--banner-active');
        }

        function closeModal() {
            if (modal) modal.classList.remove('cookie-preferences--visible');
            updateUI();
        }

        function saveCustom() {
            const newSettings = {
                analytics: analyticsChk ? analyticsChk.checked : false,
                functional: functionalChk ? functionalChk.checked : false,
                marketing: marketingChk ? marketingChk.checked : false
            };

            if (!newSettings.analytics && !newSettings.functional && !newSettings.marketing) {
                currentState = 'only_necessary';
                cookieSettings = {
                    analytics: false,
                    functional: false,
                    marketing: false
                };
            } else {
                currentState = 'customized';
                cookieSettings = newSettings;
            }
            saveToLocalStorage();
            updateUI();
            closeModal();
            if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
        }

        function resetAllCookies() {
            localStorage.removeItem(STORAGE_KEY);
            currentState = null;
            cookieSettings = {
                analytics: false,
                functional: false,
                marketing: false
            };
            if (metrikaLoaded) unloadYandexMetrika();
            updateUI();
            closeModal();
            if (rejectionOverlay) rejectionOverlay.classList.remove('cookie-rejection--visible');
        }

        function bindEvents() {
            if (acceptBtn) acceptBtn.onclick = acceptAll;
            if (rejectBtn) rejectBtn.onclick = rejectAll;
            if (customizeBtn) customizeBtn.onclick = openCustomize;
            if (savePrefBtn) savePrefBtn.onclick = saveCustom;
            if (closeModalBtn) closeModalBtn.onclick = closeModal;
            if (restoreBtn) restoreBtn.onclick = acceptAll;
            if (rejectionCustomizeBtn) rejectionCustomizeBtn.onclick = openCustomize;
            if (resetBtn) resetBtn.onclick = resetAllCookies;

            if (modal) {
                modal.onclick = function (e) {
                    if (e.target === modal) closeModal();
                };
            }
            if (rejectionOverlay) {
                rejectionOverlay.addEventListener('click', function (e) {
                    if (e.target === rejectionOverlay) {
                        rejectionOverlay.classList.remove('cookie-rejection--visible');
                    }
                });
            }
        }

        bindEvents();
        loadFromLocalStorage();
    })();
});